import { createSlice } from "@reduxjs/toolkit";

export const TransactionsSlice = createSlice({
  name: "transactions",
  initialState: {
    transactions: [],
  },
  reducers: {
    saveTransactionsData: (state, action) => {
      state.transactions = action.payload;
    }
  }
});

export const { saveTransactionsData } = TransactionsSlice.actions;
export default TransactionsSlice.reducer;